import gql from 'graphql-tag';

export const CONVERSION_DISPLAY_OPTIONS_QUERY = gql`
  query ConversionDisplayOptionsQuery($filter: AdInsightsFilterInput!) {
    conversionDisplayOptions(filter: $filter) {
      id
      name
      totalActions
      totalValue
      costPerAction
      roas
      aov
    }
  }
`;
